/* eslint-disable jsx-a11y/label-has-associated-control */
import { FC, ReactNode } from 'react';
import cx from 'classnames';

import styles from './InputGroup.module.sass';

interface InputGroupProps {
  label?: string | null;
  children: ReactNode;
  className?: string;
}

const InputGroup: FC<InputGroupProps> = ({ label, children, className }) => {
  const classes = cx(styles.group, className);

  return (
    <div className={classes}>
      {label && <label className={styles.label}>{label}</label>}
      {children}
    </div>
  );
};

export default InputGroup;
